<template>
  <v-base-question
    :url="$laravel.route('api.users.answer_quiz.commute')"
    :data="form"
    previous="quiz.country"
    next="quiz.fly"
    icon="/img/icons/svg/car.svg"
  >
    <v-input-select
      v-model="form.quiz_commute"
      required
      input-class="w-full"
      name="quiz_commute"
      label="How do you normally commute?"
    >
      <option
        v-for="(commuteOption,commuteKey) in $laravel.quiz_options.commute"
        :key="commuteKey"
        :value="commuteKey"
      >
        {{ commuteOption }}
      </option>
    </v-input-select>
    <v-input-select
      v-if="form.quiz_commute == 'car'"
      v-model="form.quiz_vehicle_type"
      required
      input-class="w-full"
      class="mt-6"
      name="quiz_vehicle_type"
      label="Vehicle type"
    >
      <option
        v-for="(vehicleTypeOption,vehicleTypeKey) in $laravel.quiz_options.vehicle_type"
        :key="vehicleTypeKey"
        :value="vehicleTypeKey"
      >
        {{ vehicleTypeOption }}
      </option>
    </v-input-select>
  </v-base-question>
</template>
<script>
import baseQuestionVue from "./baseQuestion.vue";
export default {
  name: "v-quiz-commute",
  components: {
    "v-base-question": baseQuestionVue
  },
  data() {
    return {
      form: {
        quiz_commute: "",
        quiz_vehicle_type: "",
      }
    };
  },
};
</script>
